import { toast } from 'vue-sonner';

type ToastId = string | number;

export function useActionFeedback() {
    function loading(title: string, description?: string): ToastId {
        return toast.loading(title, { description });
    }

    function success(id: ToastId | undefined, title: string, description?: string) {
        toast.success(title, { id, description });
    }

    function error(id: ToastId | undefined, title: string, description?: string, retry?: () => void) {
        toast.error(title, {
            id,
            description,
            action: retry ? { label: 'Try again', onClick: retry } : undefined,
        });
    }

    return { loading, success, error };
}
